import DashboardPatientRow from './DashboardPatientRow'

export default DashboardPatientRow



// WEBPACK FOOTER //
// ./src/legacy/components/DashboardPatientRow/index.js